import { createFileRoute } from "@tanstack/react-router";
import { AgendaEditarTarefaPage } from "@/paginas/pg_agenda/agenda-editar-tarefa";

export const Route = createFileRoute("/_authenticated/agenda-editar-tarefa")({
  head: () => ({
    meta: [
      { title: "Agenda — Editar tarefa — Milky Moo Palmares" },
      { name: "description", content: "Editar tarefa relacionada a um evento da agenda." },
    ],
  }),
  component: AgendaEditarTarefaPage,
});